import sessionStore from '@/store/session'
import leadStore from '@/store/lead'

export default function useSession() {
  // METHODS
  async function syncStoreAndSessionLead(skipSessionSync = false) {
    const sessionLead = sessionStore.getSession()
    const currentLead = leadStore.lead

    // There's already a lead in the store
    if (currentLead.leadCode && sessionLead && currentLead.leadCode === sessionLead.leadCode) {
      console.log('ALREADY SYNCED')
      // TODO: check if session-update is necessary to increase timeout
      return
    }

    if (currentLead.leadCode && sessionLead && currentLead.leadCode !== sessionLead.leadCode) {
      sessionStore.setSession(currentLead)
      return
    }
    
    if (!currentLead.leadCode && !sessionLead?.leadCode) {
      return
    }

    if (!currentLead.leadCode && sessionLead?.leadCode && !skipSessionSync) {
      const existingLead = await leadStore.getLead({ leadCode: sessionLead.leadCode })
      if (existingLead?.leadCode) {
        sessionStore.setSession(existingLead)
      }
    }
  }

  async function autostart() {
    // Session is already active, just return data
    if (sessionStore.isActive.value) {
      return sessionStore.session
    }
    
    // Try to restore session from storage
    const dataFromStorage = sessionStore.getSession()
    
    if (dataFromStorage && dataFromStorage.active) {
      // Restore session to reactive store
      sessionStore.initializeFromStorage()
      
      // Sync lead data with session
      await syncStoreAndSessionLead()
      
      return sessionStore.session
    }
    
    // Only create a completely new session if there's no existing session data
    // This should only happen on the entry screen, not during normal flow
    sessionStore.activateSession()
    return sessionStore.session
  }

  return {
    syncStoreAndSessionLead,
    autostart,
  }
}
